import * as React from 'react';
import { LanguageCode, Survey, SurveySegmentation } from '../../../../../../../amorg-common';
import { basicValidation } from '../../../../../../../amorg-common/modules/fieldValidation/basicValidation';
import { createSurveySegmentation } from '../../../../../../../api/surveyClientApi';
import { Button } from '../../../../../../../designSystem/button/Button';
import { Flex } from '../../../../../../../designSystem/compositeComponents/FlexHelpers';
import { Modal } from '../../../../../../../designSystem/Modal';
import { PageSection } from '../../../../../../../designSystem/PageSection';
import { SegmentationEditor } from './SegmentationEditor';
import { SegmentationList } from './SegmentationList';

type SegmentationPanelProps = {
    selectedLanguage:LanguageCode,
    survey:Survey,
    disableEdit:boolean,
    onUpdated:()=>void
}
export function SegmentationPanel(props:SegmentationPanelProps):JSX.Element
{
    const [inEditSegmentationIndex, setInEditSegmentationIndex] = React.useState<number | null>(null);

    async function handleClickAddNewSegmentation() {

        const nameIsVacant = (name: string) => {
            if(!basicValidation.arrayStringsAreUnique([name, ...props.survey.segmentations.map(s => s.name)]))
                return false;
            for(const l of props.survey.translationLanguages){
                const translatedNames = [
                    name,
                    ...props.survey.segmentations.map(s => s.translations.find(t => t.languageCode===l)?.name || '')
                ];
                if(!basicValidation.arrayStringsAreUnique(translatedNames))
                    return false;
            }
            return true;
        }

        let newName = 'Ny segmentering';
        let nextCount = 1;
        while (!nameIsVacant(newName)) {
            nextCount++;
            newName = `Ny segmentering ${nextCount}`;
        }

        const newest:SurveySegmentation = {
            name:newName,
            values: [ 'værdi 1', 'værdi 2'],
            translations:props.survey.translationLanguages.map(l => ({
                languageCode:l,
                name:newName,
                values: [ 'værdi 1', 'værdi 2']
            }))
        };

        const result = await createSurveySegmentation(props.survey.id, newest);

        if (!result.isSuccess)
            return;

        setInEditSegmentationIndex(null);

        props.onUpdated();
    }

    async function handleSegmentationDeleted()
    {
        setInEditSegmentationIndex(null);
        props.onUpdated();
    }

    return (
        <PageSection
            header={{
                icon:"interface_user_team",
                title:'Segmenteringer',
                defaultCollapsed:false
            }}>
            

            <Flex flexDirection="column" gap={8}>
                <SegmentationList
                    selectedLanguage={props.selectedLanguage}
                    onSurveyUpdated={() => props.onUpdated()}
                    survey={props.survey}
                    onSelectForEdit={i => {
                        setInEditSegmentationIndex(i)
                    }} />
            
                <div>
                    <Button variant="text"
                        onClick={handleClickAddNewSegmentation}
                        text={"+ Tilføj segmentering"}
                        disabled={props.disableEdit} />
                </div>
            </Flex>

            <Modal 
                title={"Segmentering"}
                content={inEditSegmentationIndex !== null &&
                    <SegmentationEditor
                        selectedLanguage={props.selectedLanguage}
                        survey={props.survey}
                        selectedSegmentationIndex={inEditSegmentationIndex}
                        onSegmentationsUpdated={props.onUpdated}
                        onDeleted={handleSegmentationDeleted}
                        onClose={() => setInEditSegmentationIndex(null)} />
                }
                showModal={inEditSegmentationIndex !== null}
                onCancel={() => setInEditSegmentationIndex(null)}/>
        </PageSection>

    );
}